export default __webpack_public_path__ + "static/media/CloseIcon.065c6859.svg";